var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Form',{staticClass:"form--single",attrs:{"id":"login"}}),_c('Social',{staticClass:"block-theme--default"}),_c('div',{staticClass:"login__ctas"},[_c('Cta',{attrs:{"data":{
        title: _vm.$labels.lost_password,
        fn: _vm.toggleRecoverPassword,
      },"theme":"small"}}),_c('Cta',{attrs:{"data":{
        title: _vm.$labels.register,
        url: '/register',
      },"theme":"small"}})],1),(_vm.showRecoverPassword)?_c('Form',{staticClass:"form--single login__recover",attrs:{"id":"recovery-password"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }